document.addEventListener('DOMContentLoaded', function () {
  initBitStudioMetaTracking();
});

var bitStudioMetaPixelState = {
  metaPixelInitialized: false,
  privacyApiLoaded: false
};

var BITSTUDIO_ATTRIBUTION_STORAGE_KEY = 'bitstudio_demo_attribution_params';

function initBitStudioMetaTracking() {
  var config = getBitStudioMetaConfig();

  persistAttributionParams(config);
  applyAttributionParamsToLandingLinks(config);
  bindLandingClickTracking(config);
  bindTryOnTracking();
  bindPrivacyConsentUpdates(config);

  withCustomerPrivacyApiReady(function () {
    initMetaPixel(config);
  });
}

function getBitStudioMetaConfig() {
  var raw = window.BitStudioDemoStoreConfig || {};
  var passThroughParams = Array.isArray(raw.passThroughParams)
    ? raw.passThroughParams
    : ['fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  return {
    enableMetaPixel: raw.enableMetaPixel !== false,
    metaPixelId: typeof raw.metaPixelId === 'string' ? raw.metaPixelId.trim() : '',
    landingHost: normalizeHost(raw.landingHost || 'virtual.fit') || 'virtual.fit',
    passThroughParams: passThroughParams
  };
}

function normalizeHost(value) {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim().replace(/^https?:\/\//i, '').replace(/\/.*$/, '').toLowerCase();
}

function getShopifyCustomerPrivacy() {
  return window.Shopify && window.Shopify.customerPrivacy
    ? window.Shopify.customerPrivacy
    : null;
}

function bindPrivacyConsentUpdates(config) {
  document.addEventListener('visitorConsentCollected', function (event) {
    var consentGranted = resolveMetaConsentGranted(event && event.detail ? event.detail : null);

    if (!bitStudioMetaPixelState.metaPixelInitialized) {
      initMetaPixel(config);
      return;
    }

    applyMetaPrivacyMode(consentGranted);
  });

  document.addEventListener('shopifyCustomerPrivacyApiLoaded', function () {
    bitStudioMetaPixelState.privacyApiLoaded = true;

    if (!bitStudioMetaPixelState.metaPixelInitialized) {
      initMetaPixel(config);
      return;
    }

    applyMetaPrivacyMode(resolveMetaConsentGranted());
  });
}

function withCustomerPrivacyApiReady(callback) {
  var resolved = false;

  function finish() {
    if (resolved) {
      return;
    }

    resolved = true;
    callback();
  }

  if (getShopifyCustomerPrivacy()) {
    bitStudioMetaPixelState.privacyApiLoaded = true;
    finish();
    return;
  }

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    window.setTimeout(finish, 0);
    return;
  }

  var fallbackTimer = window.setTimeout(finish, 1500);

  document.addEventListener('shopifyCustomerPrivacyApiLoaded', function onLoaded() {
    document.removeEventListener('shopifyCustomerPrivacyApiLoaded', onLoaded);
    bitStudioMetaPixelState.privacyApiLoaded = true;
    window.clearTimeout(fallbackTimer);
    finish();
  });

  try {
    window.Shopify.loadFeatures([
      {
        name: 'consent-tracking-api',
        version: '0.1'
      }
    ], function () {
      if (getShopifyCustomerPrivacy()) {
        bitStudioMetaPixelState.privacyApiLoaded = true;
      }

      window.clearTimeout(fallbackTimer);
      finish();
    });
  } catch (error) {
    window.clearTimeout(fallbackTimer);
    finish();
  }
}

function hasAnalyticsConsent() {
  var privacy = getShopifyCustomerPrivacy();

  if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') {
    return false;
  }

  try {
    return privacy.analyticsProcessingAllowed();
  } catch (error) {
    return false;
  }
}

function getCurrentVisitorConsent() {
  var privacy = getShopifyCustomerPrivacy();

  if (!privacy) {
    return null;
  }

  if (typeof privacy.currentVisitorConsent === 'function') {
    try {
      return privacy.currentVisitorConsent();
    } catch (error) {
      return null;
    }
  }

  return null;
}

function resolveMetaConsentGranted(consent) {
  var resolvedConsent = consent || getCurrentVisitorConsent();

  if (resolvedConsent && typeof resolvedConsent === 'object') {
    if (typeof resolvedConsent.marketingAllowed === 'boolean') {
      return resolvedConsent.marketingAllowed;
    }

    if (typeof resolvedConsent.marketing === 'boolean') {
      return resolvedConsent.marketing;
    }

    if (typeof resolvedConsent.analyticsAllowed === 'boolean') {
      return resolvedConsent.analyticsAllowed;
    }

    if (typeof resolvedConsent.analytics === 'boolean') {
      return resolvedConsent.analytics;
    }
  }

  var privacy = getShopifyCustomerPrivacy();

  if (privacy && typeof privacy.marketingAllowed === 'function') {
    try {
      return privacy.marketingAllowed();
    } catch (error) {
      return hasAnalyticsConsent();
    }
  }

  return hasAnalyticsConsent();
}

function ensureMetaPixelBase() {
  if (typeof window.fbq === 'function') {
    return true;
  }

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) {
      return;
    }

    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };

    if (!f._fbq) {
      f._fbq = n;
    }

    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  return typeof window.fbq === 'function';
}

function applyMetaPrivacyMode(granted) {
  if (typeof window.fbq !== 'function') {
    return;
  }

  if (granted) {
    window.fbq('consent', 'grant');
    window.fbq('dataProcessingOptions', []);
    return;
  }

  window.fbq('dataProcessingOptions', ['LDU'], 0, 0);
}

function initMetaPixel(config) {
  if (!config.enableMetaPixel || !config.metaPixelId || bitStudioMetaPixelState.metaPixelInitialized || !ensureMetaPixelBase()) {
    return;
  }

  applyMetaPrivacyMode(resolveMetaConsentGranted());
  window.fbq('set', 'autoConfig', false, config.metaPixelId);
  window.fbq('init', config.metaPixelId);
  window.fbq('track', 'PageView');
  bitStudioMetaPixelState.metaPixelInitialized = true;
}

function trackMetaCustomEvent(name, payload) {
  if (typeof window.fbq !== 'function') {
    return;
  }

  window.fbq('trackCustom', name, payload || {});
}

function isTrackedLandingLink(link, config) {
  if (!link || !link.href) {
    return false;
  }

  try {
    var url = new URL(link.href, window.location.origin);
    return normalizeHost(url.hostname) === config.landingHost;
  } catch (error) {
    return false;
  }
}

function loadStoredAttributionParams() {
  try {
    var raw = window.sessionStorage.getItem(BITSTUDIO_ATTRIBUTION_STORAGE_KEY);
    if (!raw) {
      return {};
    }

    var parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    return {};
  }
}

function saveStoredAttributionParams(params) {
  try {
    window.sessionStorage.setItem(BITSTUDIO_ATTRIBUTION_STORAGE_KEY, JSON.stringify(params));
  } catch (error) {
    return;
  }
}

function persistAttributionParams(config) {
  var storedParams = loadStoredAttributionParams();
  var currentParams = new URLSearchParams(window.location.search);
  var updated = false;

  config.passThroughParams.forEach(function (key) {
    var value = currentParams.get(key);
    if (!value || storedParams[key] === value) {
      return;
    }

    storedParams[key] = value;
    updated = true;
  });

  if (updated) {
    saveStoredAttributionParams(storedParams);
  }
}

function getEffectiveAttributionParams(config) {
  var effectiveParams = {};
  var currentParams = new URLSearchParams(window.location.search);

  config.passThroughParams.forEach(function (key) {
    var value = currentParams.get(key);
    if (value) {
      effectiveParams[key] = value;
    }
  });

  var storedParams = loadStoredAttributionParams();

  config.passThroughParams.forEach(function (key) {
    if (!effectiveParams[key] && storedParams[key]) {
      effectiveParams[key] = storedParams[key];
    }
  });

  return Object.keys(effectiveParams).map(function (key) {
    return [key, effectiveParams[key]];
  });
}

function applyAttributionParamsToLandingLinks(config) {
  var params = getEffectiveAttributionParams(config);

  if (params.length === 0) {
    return;
  }

  Array.prototype.slice.call(document.querySelectorAll('a[href]')).forEach(function (link) {
    if (!isTrackedLandingLink(link, config)) {
      return;
    }

    try {
      var url = new URL(link.href, window.location.origin);

      params.forEach(function (entry) {
        var key = entry[0];
        var value = entry[1];

        if (!url.searchParams.has(key)) {
          url.searchParams.set(key, value);
        }
      });

      link.href = url.toString();
    } catch (error) {
      return;
    }
  });
}

function buildLandingClickPayload(link) {
  var payload = {
    link_source: link.getAttribute('data-bitstudio-demo-link-source') || 'unknown',
    link_text: (link.textContent || '').trim(),
    product_id: link.getAttribute('data-bitstudio-demo-product-id') || null,
    product_handle: link.getAttribute('data-bitstudio-demo-product-handle') || null,
    product_title: link.getAttribute('data-bitstudio-demo-product-title') || null
  };

  try {
    var url = new URL(link.href, window.location.origin);
    payload.destination_path = url.pathname;
    payload.destination_url = url.toString();
  } catch (error) {
    payload.destination_path = '';
    payload.destination_url = link.href || '';
  }

  return payload;
}

function bindLandingClickTracking(config) {
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element
      ? event.target.closest('[data-bitstudio-demo-landing-link="true"]')
      : null;

    if (!target || !isTrackedLandingLink(target, config)) {
      return;
    }

    trackMetaCustomEvent('vfr_demo_landing_page_click', buildLandingClickPayload(target));
  }, true);
}

function normalizeProductId(value) {
  if (typeof value !== 'string') {
    return value || null;
  }

  var match = value.match(/\/(\d+)$/);
  return match ? match[1] : value;
}

function buildTryOnPayload(detail) {
  var payload = detail || {};

  return {
    tryon_id: payload.id || null,
    product_id: normalizeProductId(payload.productId),
    product_handle: payload.product_handle || payload.productHandle || null,
    product_title: payload.productTitle || null,
    page_path: window.location.pathname
  };
}

function bindTryOnTracking() {
  window.addEventListener('bitstudio-tryon-started', function (event) {
    trackMetaCustomEvent('vfr_demo_product_tryon', buildTryOnPayload(event.detail));
  });
}
